import React from 'react'
import { Box } from '@mui/material'

interface TabPanelProps {
    children?: React.ReactNode
    index: number
    value: number
}

export const TabPanel: React.FC<TabPanelProps> = props => {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`flight-tabpanel-${index}`}
            aria-labelledby={`flight-tab-${index}`}
            {...other}
            style={{ marginTop: '16px', minHeight: '100px' }}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    )
}

export const a11yProps = (index: number) => {
    return {
        id: `flight-tab-${index}`,
        'aria-controls': `flight-tabpanel-${index}`
    }
}
